const DISPLAY_TYPES = [
  { label: 'Number', value: 'number' },
  { label: 'Percentage', value: 'percentage' },
  { label: 'Bar', value: 'bar' },
  { label: 'Vacancy', value: 'vacancy' },
];

export default DISPLAY_TYPES;
